import {text_mod_16, } from "../text/Text.js";
export const module16 = {
  title:
    "Березень —​ ранок весни​",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_16, },
    ]
  }
